import clsx from 'clsx';
import React from 'react';
import { FieldValues } from 'react-hook-form';

type CheckboxProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & { errors: FieldValues['errors']; label?: string };

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  (props, ref) => {
    const { name, errors, label } = props;
    const error = name && errors[name];

    const classes = clsx(
      'p-3 text-black border-none bg-input-background',
      'focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2',
      {
        'ring-2 ring-offset-2 ring-red-500 focus:border-transparent': error,
        '': !error,
      }
    );

    return (
      <div className="text-black">
        <input
          {...props}
          id={name}
          type="checkbox"
          ref={ref}
          aria-invalid={error ? true : false}
          className={classes}
        />
        {label && (
          <label
            htmlFor={name}
            className="pl-2 align-middle"
            dangerouslySetInnerHTML={{ __html: label }}
          />
        )}
      </div>
    );
  }
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
